export default {
  button: {
    add: 'add',
    determine: 'ok',
    cancel: 'cancel',
    search: 'search',
    reset: 'reset',
    edit: 'edit',
    delete: 'delete',
    resetPassword: 'Reset Password',
    submit: 'submit',
    append: 'append',
    addFriend: 'Add Friend',
    save: 'save'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    title: 'Eastcom\'s OMS',
    fold: 'Menu Fold',
    switch: '中文/EN',
    hello: 'hello,',
    versionName: 'Version Name',
    about: 'about',
    changePassword: 'Change Password',
    menu: 'item.permisName',
    allMenus: 'All Menus',
    commonMenu: 'Common Menu'
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    remember: 'Remember Password',
    reset: 'Reset'
  },
  prompt: {
    outTips: 'This action will log out of the system, continue?',
    deleteTips: 'This action will permanently delete the information, continue?',
    deleteFailed: 'Delete Failed',
    deleteSuccessful: 'Delete Successful',
    sucessful: 'Sucessful',
    validFailed: 'Submit failed, please resubmit after review',
    submitFailed: 'Submit failed, please resubmit',
    selectLine: 'Please select a line of data',
    resetPasswordTips: 'Are you sure you want to reset your password?',
    resetPasswordSuccessful: 'Reset Password Successful',
    resetPasswordFailed: 'Reset Password Failed',
    prompt: 'prompt',
    switchTips: 'Are you sure you want to switch languages?',
    messageIsNull: 'Return message is null',
    loginTimeOut: 'Login timed out, please log in again!',
    changePasswordSuc: 'The password has been modified successfully. Please login again.'
  },
  table: {
    workWeekend: 'work on weekday',
    workTime: 'work time',
    transCode: 'Trans Code',
    transName: 'Trans Name',
    /** 系统操作日志 */ 
    operator:'Operator',
    remoteHost:'Remote Host',
    operationContent :'Operation Content',
    operationTime :'Operation Time',
    to:'To',


     /** 实时交易监控 */
    transTime:'Transaction Time',
    transType:'Transaction Type',
    transTimeCost:'Transaction Time Cost',
    channelType:'Channel Type',
    transAmount:'Transaction Amount',
    accountNum:'Account Num',
    pRetCode:'P Return Code',
    retMsg:'Return Message',

    userName: 'Name',
    account: 'Account',
    organization: 'Organization',
    numberOfSubstructures:'Number Of Substructures',

    userStatus: 'Status',
    receiveMessage: 'Rec Msg',
    mobileNo: 'Mobile-No',
    operation: 'Operation',
    choose: 'Please Choose',
    phoneNo: 'Tel-No',
    email: 'email',
    yes: 'yes',
    no: 'no',
    remark: 'remark',
    unselectedRole: 'Unselected Role',
    selectedRole: 'Selected Role',
    add: 'add',
    edit: 'edit',
    resKey: 'Resource Key',
    displayValue: 'Display Value',
    realValue: 'Real Value',
    resOrder: 'Resource Order',
    parameterKey: 'Parameter Key',
    parameterValue: 'Parameter Value',
    parameterDesc: 'Parameter Desc',
    orgName: 'Organization Name',
    shortName: 'Short Name',
    orgCode: 'Organization Code',
    orgLevel: 'Organization Level',
    orgState: 'Organization Atate',
    contUser: 'Attact User',
    postCode: 'Post Code',
    address: 'address',
    permisName: 'Permis Name',
    permisCode: 'Permis Code',
    pagePath: 'Page Path',
    permisType: 'Permis Type',
    permisUrl: 'Permis Url',
    permisOrder: 'Permis Order',
    roleName: 'Role Name',
    roleCode: 'ole Code',
    changePassword: 'Change Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    password: 'Confirm Password',

    typeCode: 'Equipment type',
    terminalId: 'Terminal Number',
    supplierName: 'supplierName',
    keywords: 'keywords',
    icon: 'icon',

    creator: 'creator',
    createDate: 'createDate',
  },
  titleTip: {
    user: 'User',
    systemParamter: 'System Paramter',
    role: 'Role',
    serviceInfo: 'Service Info'
  },
  errorLog: {
    enterName: 'Please enter name',
    enterStatus: 'Please enter status',
    enterOrg: 'Please enter Organization',
    enterAccount: 'Please enter Account',
    enterResKey: 'Please enter Resource Key',
    enterResOrder: 'Please enter Resource Order',
    enterRealValue: 'Please enter Real Value',
    enterDisplayValue: 'Please enter Display Value',
    enterParameterKey: 'Please enter Parameter Key',
    enterParameterValue: 'Please enter Parameter Value',
    enterOrgName: 'Please enter Organization Name',
    enterOrgCode: 'Please enter Organization Code',
    enterOrgLevel: 'Please enter Organization Level',
    enterOrgState: 'Please enter Organization State',
    enterPermisName: 'Please enter Permis Name',
    selectIcon: 'Please select icon',
    enterPermisCode: 'Please enter Permis Code',
    enterPermisType: 'Please enter Permis Type',
    enterRoleName: 'Please enter Role Name',
    enterRoleCode: 'Please enter Role Code',
    roleNameLength: 'Role name cannot exceed 50 characters in length',
    enterPassword: 'Password can not be blank!',
    passwordinConsistent: 'Two passwords are inconsistent',
    enterNumber: 'Please enter a number'

  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name(default excel-list)'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  }
}


// WEBPACK FOOTER //
// ./src/lang/en.js